import * as React from 'react';
import TopbarSidebarButton from '../../../../theme/pages/_layout/topbar/TopbarSidebarButton';
import TopbarProfile from './topbar-profile';
import {Link} from 'react-router-dom';

export default class Topbar extends React.PureComponent {
    public render() {
        return (
            <div className='topbar'>
                <div className='topbar__wrapper'>
                    <div className='topbar__left'>
                        <TopbarSidebarButton/>
                        <Link className='topbar__logo' to='/home'/>
                    </div>
                    <div className='topbar__right'>
                        <TopbarProfile/>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/layout/topbar/topbar.tsx